export const Constants = {
  attachments: 'Anexos',
  files: 'Arquivos',
  selectFile: 'selecionar arquivo',
  add: 'adicionar',
  edit: 'editar',
  cancel: 'cancelar',
};
